import { createIcon } from '@mote/ui/components/icon'
import { defaultProps } from './defaultProps'

export const ShieldIcon = createIcon({
  displayName: 'ShieldIcon',
  path: (
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.5'
      d='M12 4.75L4.75001 8C4.75001 8 4.00001 19.25 12 19.25C20 19.25 19.25 8 19.25 8L12 4.75Z'
    />
  ),
  defaultProps: defaultProps
})
